import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AllMatchesComponentInterface, UiComponentElementInterface } from '../../../../../../interfaces/pagebuilder';
import { setAllMatches } from '../../../../../../reduxToolkit/slices/commonSlice';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import { getMyUserMatchingsAll } from '../../../../../../services/services';
import { TitleAndDescription } from '../../../../pageBuilder/TitleAndDescription';
import { MatchList } from '../../matching/MatchList';

const AllMatchesUiComponent = ({ uiComponent }: UiComponentElementInterface<AllMatchesComponentInterface>) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const registration = useSelector(({ common }) => common.eventRegistration);
  const matches = useSelector(({ common }) => common.allMatches);

  function updateList() {
    if (registration) {
      getMyUserMatchingsAll(registration?._id).then((i) => {
        dispatch(setAllMatches(i));
      });
    }
  }

  useEffect(() => {
    updateList();
  }, [registration]);

  return (
    <div
      style={{
        color: uiComponent?.styling?.textColor || '#000',
      }}>
      <div className="w-full flex flex-col items-start justify-start">
        <TitleAndDescription component={uiComponent!} />
      </div>
      <MatchList
        list={matches?.filter((i) => i.score >= uiComponent?.minimumScore!)}
        disableScore={uiComponent?.disableScoreWhenZero!}
        updateList={updateList}
      />
    </div>
  );
};

export default AllMatchesUiComponent;
